// no jquery
var favorites = function(){
	"use strict";	
	var origFocus,
	
	init = function(){
		// index favorites page
		if(document.querySelector('.create-board')){ 
			if(document.querySelector('.create-board').classList.contains('userLoggedIn')){
				document.querySelector('.create-board').addEventListener('click', function(e){ 
		    			e.preventDefault();
		    			ajaxActions.EditBoard(this);	
		    		});
		    	}
		    	var deleteBoards = [].slice.call(document.querySelectorAll('.delete-board'));
		    	deleteBoards.forEach(function(el, index, array){
			    	el.addEventListener('click', function (e) { 
			    		e.preventDefault();
			    		origFocus = el;
			   		Dialogs.OpenDelete(el);
			    	});
			});
			var editBoards = [].slice.call(document.querySelectorAll('.edit-board'));
		    	editBoards.forEach(function(el, index, array){
				el.addEventListener('click', function (e) { 
			    		e.preventDefault();
			    		origFocus = el;
			    		ajaxActions.EditBoard(el); 
				});
			});
		// view board page
		}else{ 
			var deleteItemBtns = [].slice.call(document.querySelectorAll('.delete-item'));
		    	deleteItemBtns.forEach(function(el, index, array){
			    	el.addEventListener('click', Dialogs.DeleteItem);
			});
			//omniture logging
		    	var products = [].slice.call(document.getElementsByClassName('viewProduct'));
		    	products.forEach(function(el, index, array){
		    		el.addEventListener('click', function(e){
			    		e.preventDefault();
			    		omniture.ViewProductClick();
			    		window.location = e.currentTarget.href;
			    	});
		    	});
		    	
		    	if(document.querySelector(".skipToCompare")){
		    		document.querySelector(".skipToCompare").addEventListener('click', function(e){
		    			e.preventDefault();
		    			if(document.getElementById("compareBox")){
		    				document.getElementById("compareBox").scrollIntoView({behavior: "smooth"});
		    				document.getElementById("compareItemsBtn").focus();
		    			}else{ 
		    				window.scrollTo({
							top: 0,
							behavior: "smooth"
						});
						document.querySelector(".boardMiscLinks").querySelector("a").focus();
		    			}
		    		});
		    	}
			SharePanel.ClickEvents();
		}
		//both pages
		
		// aria labels need to be different on the two paging areas but the way 
		// they are set up I am unsure how to do it besides this hack:
		var paging = [].slice.call(document.querySelectorAll(".pagingLinks"));
		if(paging[0]){
			paging[0].setAttribute("aria-label", "First Paging Navigation of Boards");
			paging[1].setAttribute("aria-label", "Last Paging Navigation of Boards");
		}
		
		var pageBtns = [].slice.call(document.querySelectorAll('.change-page'));
	 	pageBtns.forEach(function(el, index, array){
			el.addEventListener('click', function (e) { 
		    		e.preventDefault();
				ajaxActions.NewPage(el);
		    	});
	    	});
	    	var prevPageBtns = [].slice.call(document.querySelectorAll('.change-page-previous'));
	 	prevPageBtns.forEach(function(el, index, array){
			el.addEventListener('click', function (e) { 
		    		e.preventDefault();
				ajaxActions.NewPage(el);
		    	});
	    	});
	    	var nextPageBtns = [].slice.call(document.querySelectorAll('.change-page-next'));
	 	nextPageBtns.forEach(function(el, index, array){
			el.addEventListener('click', function (e) { 
		    		e.preventDefault();
		    		if(el.classList.contains('disabled')){
		    			return false;
		    		}
				ajaxActions.NewPage(el);
			});
		});

		NotePanels.ClickEvents();
	},
	//end Init
	
	SharePanel = (function(){
		var panel = document.querySelector('.sharing-panel');
		
		var clickEvents = function(){
			if(document.getElementById('sendEmail')){
				document.getElementById('sendEmail').addEventListener('click', sendEmail);
			}
		     	if(document.querySelector('.shareBoard')){
		     		document.querySelector('.shareBoard').addEventListener('click', toggleSharePanel);
			}
		    	if(document.querySelector('.cancel-sharepnl')){
		    		document.querySelector('.cancel-sharepnl').addEventListener('click', closePanel); 
		    	}
			if(document.getElementById('copyToClipBoard')){
				document.getElementById('copyToClipBoard').addEventListener('click', copyLink);
			}
		},
		toggleSharePanel = function(e){
			e.preventDefault();
			if (panel.classList.contains("hide")){
	    			panel.classList.add("fadeInDown");
	    			panel.classList.remove("hide");
	    			document.querySelector('.shareBoard').setAttribute("aria-expanded", "true");
	    		}else {
	    			panel.classList.remove("fadeInDown");
	    			panel.classList.add("hide");
	    			document.querySelector('.shareBoard').setAttribute("aria-expanded", "false");
	    		}
		},
		copyToClipboard = function(el) {
	  		var temp = document.createElement("input");
	  		temp.value = el.value;
	  		
	  		var isiOSDevice = navigator.userAgent.match(/ipad|iphone/i);
			if (isiOSDevice) {
				var editable = temp.contentEditable;
				var readOnly = temp.readOnly;
		
				temp.contentEditable = true;
				temp.readOnly = false;
		
				var range = document.createRange();
				range.selectNodeContents(temp);
		
				var selection = window.getSelection();
				selection.removeAllRanges();
				selection.addRange(range);
		
				temp.setSelectionRange(0, 999999);
				temp.contentEditable = editable;
				temp.readOnly = readOnly;
			} else {
				document.getElementsByTagName('body')[0].appendChild(temp);
	  			temp.select();
	  			document.execCommand("copy");
	  			temp.parentNode.removeChild(temp);
	  		}
	  		
	  		return true;
		},
		copyLink = function(){
	    		if(copyToClipboard(document.querySelector('#share-url'))){
				document.querySelector('.copyConfirm').innerHTML = '<svg class="textGreen inlineMiddle" height="20px" width="20px" aria-hidden="true"><use xlink:href="#svgIcon-checkMarkBox"></use></svg> <span class="inlineMiddle">Link Copied!</span>';
				document.querySelector('.copyConfirm').classList.remove("hide");
	    		}
	    		document.getElementById("copyToClipBoard").focus();
		},
		closePanel = function(){
	    		panel.classList.remove("fadeInDown");
	    		panel.classList.add("hide");
	    		
	    		 if(document.querySelector('.copyConfirm')){
	    		 	document.querySelector('.copyConfirm').innerHTML = "";
	    		 	document.querySelector('.copyConfirm').classList.add("hide");
	    		 }
	    		 document.getElementById("shareEmail").classList.remove("input-validation-error");
	    		 document.getElementById("shareEmail").parentNode.querySelector(".errorMessage").classList.add("hide");

	    		 if(document.getElementById('emailSent')){
	    		 	document.getElementById('emailSent').parentNode.removeChild(document.getElementById('emailSent'));
	    		 }
	    		 document.querySelector('.shareBoard').setAttribute("aria-expanded", "false");
	    		 document.querySelector(".shareBoard").focus();
		},
		validateEmail = function(e){
	   		var filter = /^([\w-&+\'\.]+(?:\.[\w-]+)*)@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z\-]{2,24}(?:\.[a-z\-]{2})?)$/i;
	   		return filter.test(e);
	 	},
		sendEmail = function(e){
			e.preventDefault();
			var form = document.querySelector('#emailDiv');
	 		if(form.querySelector('.ErrorMsgPanel')){
	    			form.querySelector('.ErrorMsgPanel').parentNode.removeChild(form.querySelector('.ErrorMsgPanel'));
	    		}
	    		if(document.getElementById('emailSent')){
	    			document.getElementById('emailSent').parentNode.removeChild(document.getElementById('emailSent'));
	    		}
	    		var email = document.getElementById('shareEmail');
	    		if(!validateEmail(email.value)){
	    			email.classList.add("input-validation-error");
	    			email.parentNode.querySelector(".errorMessage").classList.remove("hide");
	    			email.focus();
	    			return false;  		
	    		}
	    		omniture.SendBtnClick();
	    		ajaxActions.ShareBoard(email);
		};
		return{
			ClickEvents: clickEvents
		};
	})(),
	
	NotePanels = (function(){
		var clickEvents = function(){
			var noteLabels = [].slice.call(document.getElementsByClassName('note-label'));
		 	noteLabels.forEach(function(el, index, array){
		 		el.removeEventListener('click', showNotes);
			 	el.addEventListener('click', showNotes);
			});
			var editItemNotes = [].slice.call(document.getElementsByClassName('edit-item-note'));
			editItemNotes.forEach(function(el, index, array){
				el.removeEventListener('click', showNotes);
			 	el.addEventListener('click', showNotes);
			});
			var removeItemNotes = [].slice.call(document.getElementsByClassName('remove-item-note'));
			removeItemNotes.forEach(function(el, index, array){
				el.removeEventListener('click', ajaxActions.RemoveNote);
				el.addEventListener('click', ajaxActions.RemoveNote);
			});
			var submitNotes = [].slice.call(document.getElementsByClassName('submit-item-note'));
		 	submitNotes.forEach(function(el, index, array){
		 		el.removeEventListener('click', ajaxActions.SaveNote);
				el.addEventListener('click', ajaxActions.SaveNote);
		    	});
		    	var cancelNotes = [].slice.call(document.getElementsByClassName('cancel'));
		 	cancelNotes.forEach(function(el, index, array){
		 		el.removeEventListener('click', hideNotes);
			    	el.addEventListener('click', hideNotes);
		    	});
		},
		savedEvents = function(){
			var editItemNotes = [].slice.call(document.getElementsByClassName('edit-item-note'));
			editItemNotes.forEach(function(el, index, array){
				el.removeEventListener('click', showNotes);
			 	el.addEventListener('click', showNotes);
			});
			
			var removeItemNotes = [].slice.call(document.getElementsByClassName('remove-item-note'));
			removeItemNotes.forEach(function(el, index, array){
				el.removeEventListener('click', ajaxActions.RemoveNote);
				el.addEventListener('click', ajaxActions.RemoveNote);
			});
		},
		showNotes = function(e){
			e.preventDefault();
			var el = e.currentTarget;
			var notePanel = el.parentNode.querySelector(".note-panel");
			var addNoteLink = el.parentNode.querySelector('.add-item-note');
			var editNoteLink = el.parentNode.querySelector('.edit-item-note');
	    		if(notePanel.classList.contains('hide')){
	    			notePanel.classList.add('fadeInDown');
	    			notePanel.classList.remove('hide');
				addNoteLink.setAttribute('aria-expanded', 'true');
				editNoteLink.setAttribute('aria-expanded', 'true');
	    			notePanel.querySelector('.item-note').focus();
	    		} else {
	    			notePanel.classList.remove('fadeInDown');
	    			notePanel.classList.add('hide');
				editNoteLink.setAttribute('aria-expanded', 'false');
				addNoteLink.setAttribute('aria-expanded', 'false');
	    			el.focus();
	    		}
			if (el.parentNode.querySelector('.note-display').textContent != "") {
				el.parentNode.querySelector('.item-note').value = el.parentNode.querySelector('.note-display').textContent; 
			}
	 	},
	 	hideNotes = function(e){
	 		e.preventDefault();
			var el = e.currentTarget;
	 		var notePanel = el.parentNode.parentNode;
	 		var noteArea = el.parentNode.parentNode.parentNode;
	 		noteArea.querySelector('.edit-item-note').setAttribute('aria-expanded', 'false');
			noteArea.querySelector('.add-item-note').setAttribute('aria-expanded', 'false');
	    		notePanel.classList.remove('fadeInDown');
	    		notePanel.classList.add('hide');
	    		if(noteArea.querySelector(".note-display").textContent == ""){
	    			noteArea.querySelector("button").focus();
	    		}else{
	    			noteArea.querySelectorAll("button")[1].focus();
	    		}
	 	};
		return {
			ClickEvents: clickEvents,
			SavedEvents: savedEvents
		};
	})(),

	Dialogs = (function(){
		var clickEvents = function(el){
			document.querySelector('.cancel-delete').addEventListener('click', function (e) { 
		    		e.preventDefault();
		    		var item = el.parentNode.parentNode.parentNode.parentNode; //.favorite-list
		    		item.querySelector('.dialog-box').parentNode.removeChild(item.querySelector('.dialog-box'));
		    		item.querySelector('.roundedCorner').removeAttribute('style');   
		    		if(item.querySelector('.delete-item')){
		    			item.querySelector('.delete-item').focus();
		    		}else{
		    			item.querySelector('.delete-board').focus();
		    		}
			});
			if(document.querySelector('.confirm-delete-board')){ // index page
				document.querySelector('.confirm-delete-board').addEventListener('click', ajaxActions.DeleteBoard);
			}
			if(document.querySelector('.confirm-delete')){ // board page
				document.querySelector('.confirm-delete').addEventListener('click', ajaxActions.DeleteItem);
			}
		},
		openDelete = function(el){
			var dialog = create('board');
	   		var template = el.parentNode.parentNode.parentNode.parentNode; //.boardTemplate'
	   		var newDiv = document.createElement('div');
	   		newDiv.innerHTML = dialog;
	    		template.appendChild(newDiv);
	    		template.querySelector('.confirm-delete-board').focus();
	    		template.querySelector('.dialog-box').focus();
	    		el.parentNode.parentNode.parentNode.querySelector('.boardImages').style.opacity = 0.3; 
	    		clickEvents(el);
		},
		create = function(e){
		  	var dialog;
			if(e == 'board'){
				dialog = 
				'<div class="dialog-box removeBoardBox bkgdWhite paddingBtm10">' +
		    			'<p class="text14 textBlue semibold margin10">Are you sure you want to remove this board?</p>' +
		    			'<p class="text14 semibold margin10">Note: All items in it will also be deleted.</p>' +
		    			'<div class="displayFlex margin10">' +
		    				'<div class="marginRight10"><button class="text16 confirm-delete-board button-md bkgdBlue whiteLink">Remove</button></div>' + 
		    				'<button class="text16 cancel-delete button-sm button-white-textBlue" >Cancel</button>' +
		    			'</div>' +
		    	 	'</div>';
			} else {
				dialog = 
				'<div class="dialog-box bkgdWhite paddingBtm10">' +
		    			'<p class="text14 textBlue semibold margin10">Are you sure you want to delete this item?</p>' +
		    			'<div class="displayFlex margin10">' +
		    				'<div class="marginRight10"><button class="text16 confirm-delete button-md bkgdBlue whiteLink">Remove</button></div>' + 
		    				'<button class="text16 cancel-delete button-sm button-white-textBlue" >Cancel</button>' +
		    			'</div>' +
		    	 	'</div>';
			}
			return dialog;
		},
		deleteItem = function(e){ 
			e.preventDefault();
			var el = e.currentTarget;
 			var dialog = create('item');
	    		var template = el.parentNode.parentNode.parentNode.parentNode; //.favorite-list
	    		var newDiv = document.createElement('div');
	    		newDiv.innerHTML = dialog;
	    		template.appendChild(newDiv);
	    		template.querySelector('.confirm-delete').setAttribute('tabindex', '0');
	    		template.querySelector('.confirm-delete').focus();
	    		template.querySelector('.cancel-delete').setAttribute('tabindex', '0');
	    		el.parentNode.parentNode.parentNode.style.opacity = 0.3; //.list-item
			clickEvents(el);
	 	};
		return {
			ClickEvents: clickEvents,
			OpenDelete: openDelete,
			DeleteItem: deleteItem,
			Create: create
		};
	})(),
	
	NewBoard = (function(){
		var clickEvents = function(){
			var cancelBoards = [].slice.call(document.querySelectorAll('.cancel-new-board'));
			cancelBoards.forEach(function(el, index, array){
				el.addEventListener('click', cancel);
			});
			document.getElementById('submitNewBoard').addEventListener('click', create);
		},
		create = function(e){
			e.preventDefault();
			var el = e.currentTarget;
			var form = document.querySelector('#newBoardForm');
			var boardName = document.getElementById('BoardName');
			if(form.querySelector('.ErrorMsgPanel')){
	    			form.querySelector('.ErrorMsgPanel').parentNode.removeChild(form.querySelector('.ErrorMsgPanel'));
	    		}
	    		if(boardName.value == ''){
	    			boardName.classList.add("input-validation-error");
	    			boardName.parentNode.querySelector(".errorMessage").textContent = "Please enter a board name.";
	    			boardName.parentNode.querySelector(".errorMessage").classList.remove("hide");
	    			boardName.focus();
	    			return false;  		
	    		}
	    		ajaxActions.CreateBoard(el);
		},
		cancel = function(e){
			e.preventDefault();
			var form = document.querySelector('#newBoardForm');	
			form.classList.add('slideLeft');
			//remove board after the animation has had time to play
			setTimeout(function() {
				form.parentNode.removeChild(form);
			  }, 250);
			document.querySelector('.create-board').setAttribute('aria-expanded', 'false');
			document.querySelector('.create-board').focus();
		};
		return{
			ClickEvents: clickEvents
		};
	})(),
	
	Boards = (function(){
		var clickEvents = function(){
			var cancelUpdateLinks = [].slice.call(document.querySelectorAll('.cancel-board-update'));
		    	cancelUpdateLinks.forEach(function(el, index, array){
				el.addEventListener('click', cancelUpdate);
			});
		    	document.getElementById('submitBoardUpdate').addEventListener('click', update);
		},	
		cancelUpdate = function(e){
			e.preventDefault();
			var form = document.querySelector('#editBoardForm');
	     		form.classList.add('slideLeft');
	     		//remove board after the animation has had time to play
	     		setTimeout(function() {
				form.parentNode.removeChild(form);
				origFocus.focus();
			}, 250);
		},
		update = function(e){
			e.preventDefault();
			var form = document.querySelector('#editBoardForm');
	    		var boardName = document.querySelector('#BoardName');
	    		if(form.querySelector('.ErrorMsgPanel')){
	    			form.querySelector('.ErrorMsgPanel').parentNode.removeChild(form.querySelector('.ErrorMsgPanel'));
	    		}
	    		if(boardName.value == ''){
	    			boardName.classList.add("input-validation-error");
	    			boardName.parentNode.querySelector(".errorMessage").textContent = "Please enter a board name.";
	    			boardName.parentNode.querySelector(".errorMessage").classList.remove("hide");
	    			boardName.focus();
	    			return false;  		
	    		}
	    		ajaxActions.UpdateBoard(form);
		};
		return {
			ClickEvents: clickEvents
		};
	})(),
	
	Paging = (function(){
		var update = function(el, data){
		   	var paging = [].slice.call(document.getElementsByClassName('change-page'));
		   	paging.forEach(function(el, index, array){
				el.classList.remove('bkgdLtGray');
				el.classList.remove('semibold');
			});
			if(el.classList.contains('change-page-previous') == true || el.classList.contains('change-page-next') == true){
				el.parentNode.getElementsByClassName(data.pageNum).classList.add('bkgdLtGray');
				el.parentNode.getElementsByClassName(data.pageNum).classList.add('semibold');
			}else{
				el.classList.add('bkgdLtGray');
				el.classList.add('semibold');
			}
			var maxPages = parseInt(document.getElementById('maxPages').value);
			if (parseInt(data.pageNum) == maxPages){ 
				document.querySelector('.change-page-next').classList.add('disabled'); 
				document.querySelector('.change-page-next').classList.add('textLtGray'); 
			} else {
				document.querySelector('.change-page-next').classList.remove('disabled');
				document.querySelector('.change-page-next').classList.remove('textLtGray');
			}
			var hrefPrev =  (parseInt(data.pageNum) == 1) ? '/1'  : (parseInt(data.pageNum) - 1);
			var hrefNext = (parseInt(data.pageNum) == maxPages) ? maxPages  : (parseInt(data.pageNum) + 1);
			document.querySelector('.change-page-previous').setAttribute('href', hrefPrev );
			document.querySelector('.change-page-next').setAttribute('href', hrefNext);
			
			//var x = window.location.pathname; // NOT USED
			var stateObj = { path : window.location.pathname };
			history.replaceState(stateObj, data.pageNum, '/favs/board/' + data.boardID + '/' +data.pageNum);
		};
		return{
			Update: update
		};
	})(),

	omniture = (function () {
		var sendBtnClick = function () {
			const account = typeof s_account === 'string' ? s_account : '4imprintprod';
			const s = typeof s_gi === 'function' ? s_gi(account) : '';
			if (s) {
			  s.linkTrackVars = 'prop24';
			  s.linkTrackEvents = 'None';
			  s.prop24 = "Fav Board Share";//Share board,log click event
			  s.tl(true, 'o', 'Fav Board Share');
			}
		};
		var viewProductClick = function () {
			const account = typeof s_account === 'string' ? s_account : '4imprintprod';
			const s = typeof s_gi === 'function' ? s_gi(account) : '';
			if (s) {
			  s.linkTrackVars = 'eVar36';
			  s.linkTrackEvents = 'none';
			  s.eVar36 = "Fav Boards Conversions";//Product click event variable expires at purchase
			  s.tl(true, 'o', 'Fav Boards Conversions');
			}
		};
		var logNewBoardCreation = function () {
			const account = typeof s_account === 'string' ? s_account : '4imprintprod';
			const s = typeof s_gi === 'function' ? s_gi(account) : '';
			if (s) {
			  s.linkTrackVars = 'prop26';
			  s.linkTrackEvents = 'None';
			  s.prop26 = "Fav Board Creations";//New board, log create event
			  s.tl(true, 'o', 'Fav Board Creations');
			}
		};
		return {
			SendBtnClick: sendBtnClick,
			ViewProductClick: viewProductClick,
			LogNewBoardCreation: logNewBoardCreation
		};
	})(),
	
	ajaxActions = (function(){
		var headerToken = document.querySelectorAll('input[name=__RequestVerificationToken]')[0].value,
		removeNote = function(e){
			//TODO how can we simplify this?
			e.preventDefault();
			var el = e.currentTarget;
			var noteArea = el.parentNode; //.note-area
			var noteLabel = noteArea.querySelector('.note-label');
			var notePanel = noteArea.querySelector('.note-panel');
			var editNoteLink = noteArea.querySelector('.edit-item-note');
			var removeNoteLink = noteArea.querySelector('.remove-item-note');
			var addNoteLink = noteArea.querySelector('.add-item-note');
			var noteDisplay = noteArea.querySelector('.note-display');
			var noteInput = noteArea.querySelector('.item-note');
	    		var boardItemID = noteArea.querySelector('.board-item-id') ? noteArea.querySelector('.board-item-id').value : "";
	    		var note = '';
	    		var data;
	    		if(boardItemID == ""){
	    			data = { boardID: noteArea.querySelector('.board-id').value, note: note, boardItemID: boardItemID};
	    		} else{
	    			data = { boardID: -1 , note: note ,  boardItemID : boardItemID};
	    		}
	    		
			fetch('/favs/addnote', { 
	        		method: 'POST', 
	        		credentials: 'same-origin',
	        		body: JSON.stringify(data), 
	        		headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'fetch', '__RequestVerificationToken': headerToken  }
			}).then(function(response){
				return  (response.ok) ? response.json() : []; // response.json() returns a promise
			}).then(function(response){
				if(response.success == 'true'){
					noteLabel.classList.remove('hide'); 
					noteLabel.innerHTML = 'Add Notes';
					notePanel.classList.remove('fadeInDown');
					notePanel.classList.add('hide');
					noteDisplay.innerHTML = '';
	       			editNoteLink.classList.add('hide');
	       			editNoteLink.setAttribute('aria-expanded', 'false'); 
	       			removeNoteLink.classList.add('hide');
	       			noteInput.value = "";
					addNoteLink.setAttribute('role', 'link');
					if(noteArea.parentNode.parentNode.classList.contains("boardTemplate")){
						noteArea.parentNode.parentNode.querySelector('.lastModifiedDate').innerHTML = 'Item was last modified <span class="textsemibold">today</span>';
					}
					noteLabel.focus();
	       		}
			});
		},
		saveNote = function(e){
			//TODO how can we simplify this?
			e.preventDefault();
			var el = e.currentTarget;
			var noteArea = el.parentNode.parentNode.parentNode.parentNode;
			var editNoteLink = noteArea.querySelector('.edit-item-note');
			var addNoteLink = noteArea.querySelector('.add-item-note');
			var removeNoteLink = noteArea.querySelector('.remove-item-note');
			var noteLabel = noteArea.querySelector('.note-label');
			var notePanel = noteArea.querySelector('.note-panel');
			var boardID = noteArea.querySelector(".board-id") ? noteArea.querySelector(".board-id").value : "";
			var boardItemID = noteArea.querySelector('.board-item-id') ? noteArea.querySelector('.board-item-id').value : "";
			var note = noteArea.querySelector('.item-note').value;			
			var data = { BoardID: boardID, BoardItemID : boardItemID, Note: note };
			
			editNoteLink.setAttribute('aria-expanded', 'false');
			addNoteLink.setAttribute('aria-expanded', 'false');
			if (addNoteLink.value.length > 0) { 
				addNoteLink.classList.add('hide'); 
			} 
			
			fetch('/favs/addnote', { 
	        		method: 'POST', 
	        		credentials: 'same-origin',
	        		body: JSON.stringify(data), 
	        		headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'fetch', '__RequestVerificationToken': headerToken  }
			}).then(function(response){
				return  (response.ok) ? response.json() : []; // response.json() returns a promise
			}).then(function(response){
				if(note == ''){
					noteLabel.classList.remove('hide');
					noteLabel.innerHTML = 'Add Notes';
		            	  	editNoteLink.classList.add('hide');
		            	  	removeNoteLink.classList.add('hide');
		            	  } else{
		            	  	noteLabel.classList.add('hide'); 
		            	  	noteLabel.innerHTML = '';
		            	  	editNoteLink.classList.remove('hide');
		            	  	removeNoteLink.classList.remove('hide');
					addNoteLink.removeAttribute('role');
		            	  }
		            	  if(response.success == 'true'){
		            	  	noteArea.querySelector('.note-display').innerHTML = note;
		            	  }
		            	  
		            	  notePanel.classList.remove('fadeInDown');
		            	  notePanel.classList.add('hide');
		            	  
		            	  if(editNoteLink){
		            	  	editNoteLink.focus();
		            	  }else{
		            	  	document.querySelector(".note-area").querySelector(".note-label").focus();
		            	  }

		            	  if(noteArea.parentNode.parentNode.querySelector(".lastModifiedDate")){
		            	  	noteArea.parentNode.parentNode.querySelector(".lastModifiedDate").innerHTML = 'Item was last modified <span class="textsemibold">today</span>';
		            	  }
		            	  NotePanels.SavedEvents();
			});
		},
		shareBoard = function(el){
			var boardID = document.querySelector('.board-id').value;
			fetch('/favs/shareboard', { 
	        		method: 'POST', 
	        		credentials: 'same-origin',
	        		body: JSON.stringify({ boardID: boardID, email: el.value }), 
	        		headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'fetch', '__RequestVerificationToken': headerToken }
			}).then(function(response){
				return  (response.ok) ? response.json() : []; // response.json() returns a promise
			}).then(function(response){
				if(response.success == 'true'){
		              	el.value = '';
		              	el.classList.remove("input-validation-error");
		              	el.parentNode.querySelector(".errorMessage").classList.add("hide");
		              	el.parentNode.querySelector(".errorMessage").insertAdjacentHTML('afterend', '<p id="emailSent" role="alert" aria-atomic="true" class="textBlue textsemibold text14"><svg class="textGreen inlineMiddle" height="20px" width="20px" aria-hidden="true"><use xlink:href="#svgIcon-checkMarkBox"></use></svg>'  + response.message + '<\p>');
		              }
			});
		},
		deleteBoard = function(e){
			var target = e.currentTarget;
			var el = target.parentNode.parentNode.parentNode.parentNode.parentNode;
			var boardID = el.querySelector('.board-id').value;
			
			fetch('/favs/deleteboard', { 
	        		method: 'POST', 
	        		body: JSON.stringify({ boardID: boardID }), 
	        		headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'fetch' }
			}).then(function(response){
				return  (response.ok) ? response.json() : []; // response.json() returns a promise
			}).then(function(response){
				if(response.success == "true"){
		              	el.classList.add('remove');
		              	//remove board after animation has time to play
		              	setTimeout(function () {
					    el.parentNode.removeChild(el); 
					    document.querySelector(".create-board").focus();
					}, 300);
		              }
			});
		},
		deleteItem = function(e){
			e.preventDefault();
			var el = e.currentTarget;
			var boardID = document.querySelector('.board-id').value;
			var boardToDelete = el.parentNode.parentNode.parentNode.parentNode.parentNode; //.favorite-list
			var boardItemID = boardToDelete.querySelector('.board-item-id').value;
			var productID = boardToDelete.querySelector('.product-id').value;
			
			fetch('/favs/deleteboarditem', { 
	        		method: 'POST', 
	        		body: JSON.stringify({ boardID: boardID, boardItemID : boardItemID, productID : productID }), 
	        		headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'fetch' }
			}).then(function(response){
				return  (response.ok) ? response.json() : []; // response.json() returns a promise
			}).then(function(response){
				if(response.success == "true"){
		               	if(response.message == "empty"){
		               		boardToDelete.classList.add('remove');
		               		//remove item after animation has time to play
		               		setTimeout(function (){
		               			boardToDelete.parentNode.removeChild(boardToDelete);
		               		}, 300);
		               		var newDiv = document.createElement('div');
		               		newDiv.innerHTML = response.partialView;
		                   		document.getElementById('masterView').append(newDiv);
		                	} 
		               	boardToDelete.classList.add('remove');
		               	//remove item after animation has time to play
		               	setTimeout(function (){
		               		boardToDelete.parentNode.removeChild(boardToDelete);
		               		document.getElementsByClassName("favActionLinks")[0].getElementsByTagName("a")[0].focus();
		               	}, 300);
		               }
			}).catch(function(error){
				var status = document.createElement('p');
				status.classList.add("textDkRed");
				status.classList.add("textsemibold");
				status.setAttribute("role", "status");
				status.textContent = 'Oops! There was an error saving your note.';
				el.parentNode.parentNode.getElementsByClassName('item-note')[0].insertBefore(status, el.parentNode.parentNode.getElementsByClassName('item-note')[0].firstChild);
			});
		},
		createBoard = function(el){
			var boardName = document.getElementById('BoardName').value;
			var isDefaultBoard = document.getElementById('IsDefaultBoard').checked == true;
			var note = document.getElementById('Notes').value;
			var headerToken = document.querySelectorAll('input[name=__RequestVerificationToken]')[0].value;
			
			if(document.getElementsByClassName('boardTemplate').length == 1){
				isDefaultBoard = true;
			}

			fetch('/favs/addnewboard', { 
	        		method: 'POST', 
	        		credentials: 'same-origin',
	        		body: JSON.stringify({ Name: boardName, CreatedDate : null, GURID: '', IsDefaultBoard: isDefaultBoard, Notes: note }), 
	        		headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'fetch', '__RequestVerificationToken': headerToken  }
			}).then(function(response){
				return  (response.ok) ? response.text() : []; // response.text() returns a promise
			}).then(function(response){
				//TODO: New Board template returned in result. Replace param e with new content to avoid page load
	            		//reload for the time being
	            		//Log new board in omniture         		
	            		if(response.length > 1){
	            			omniture.LogNewBoardCreation();
	            			location.reload();
	            			return false;
	            		}
	            		boardName.classList.add("input-validation-error");
	            		boardName.parentNode.querySelector(".errorMessage").textContent = response;
	            		boardName.parentNode.querySelector(".errorMessage").classList.remove("hide");
	    			boardName.focus();
			});
		},
		updateBoard = function(el){	
			var boardID = el.querySelector('.board-id');
			var boardName = el.querySelector('.boardName').value;
			var isDefaultBoard = document.getElementById('IsDefaultBoard').checked == true;
			var note = el.querySelector('.boardNote').value;

			fetch('/favs/updateboard', { 
	        		method: 'POST', 
	        		credentials: 'same-origin',
	        		body: JSON.stringify({ BoardID: boardID.value, Name: boardName, IsDefaultBoard: isDefaultBoard, Notes: note }), 
	        		headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'fetch', '__RequestVerificationToken': headerToken  }
			}).then(function(response){
				return  (response.ok) ? response.text() : []; // response.text() returns a promise
			}).then(function(response){
				 //TODO: New Board template returned in result. Replace param e with new content to avoid page load
	            		//reload for the time being
	            		if(response.length > 1){
	            			location.reload();
	            			return false;
	            		}
	            		
	            		boardName.classList.add("input-validation-error");
	            		boardName.parentNode.querySelector(".errorMessage").textContent = response;
	            		boardName.parentNode.querySelector(".errorMessage").classList.remove("hide");
	    			boardName.focus();
			});
		},
		editBoard = function(el){
			if(document.querySelector('.boardAddedMsg')){
	    			document.querySelector('.boardAddedMsg').parentNode.removeChild(document.querySelector('.boardAddedMsg'));
	    		}
			var boardID;
			if(el.parentNode.querySelector('.board-id')){
				boardID = el.parentNode.querySelector('.board-id').value;
			}
			var data = {	boardID: boardID	};
			
			if(el.classList.contains('create-board')){
				if(document.getElementById('newBoardForm')){
					document.getElementById('newBoardForm').classList.remove('hide');
					document.getElementById('newBoardForm').classList.remove('slideLeft');
					document.getElementById('newBoardForm').classList.add('slideRight');
					return false;
				}
				data = {	boardID: 0, isNewBoard: true };
			}	
			
			fetch('/favs/editboard', { 
	        		method: 'POST', 
	        		body: JSON.stringify(data), 
	        		headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'fetch' }
			}).then(function(response){
				return  (response.ok) ? response.text() : []; // response.text() returns a promise
			}).then(function(response){
				el.parentNode.insertAdjacentHTML('afterend', response);
		              if(el.classList.contains('create-board')){ 
		               	document.getElementById('newBoardForm').classList.remove('hide');
		               	document.getElementById('newBoardForm').classList.remove('slideLeft');
					document.getElementById('newBoardForm').classList.add('slideRight');
		               	document.getElementById('BoardName').focus();
		               	el.setAttribute('aria-expanded', 'true');
		               	NewBoard.ClickEvents();
		               } else {
		               	document.getElementById('editBoardForm').classList.remove('hide');
		               	document.getElementById('editBoardForm').classList.remove('slideLeft');
		               	document.getElementById('editBoardForm').classList.add('slideRight');
		               	document.getElementById('BoardName').focus();
		               	Boards.ClickEvents();
		               }
			});
		},
		newPage = function(el){
    			var pageNum = el.getAttribute('href');
	    		var boardID = document.getElementById('boardID').value;
	    		var data = { boardID : boardID, pageNum : pageNum };
	    		
	    		fetch('/favs/getajaxboarditems', { 
	        		method: 'POST', 
	        		body: JSON.stringify(data), 
	        		headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'fetch' }
			}).then(function(response){
				return  (response.ok) ? response.text() : []; // response.text() returns a promise
			}).then(function(response){
				document.getElementById('masterView').innerHTML = response;
	            		Paging.Update(el, response);
	            		var pagingRange = document.getElementById('masterView').getElementsByClassName('paging-range')[0].innerHTML;
	            		document.getElementsByClassName('paging-range')[0].innerHTML = pagingRange;
			});
		};
		return{
			RemoveNote: removeNote,
			SaveNote: saveNote,
			ShareBoard: shareBoard,
			DeleteBoard: deleteBoard,
			DeleteItem: deleteItem,
			CreateBoard: createBoard,
			UpdateBoard: updateBoard,
			EditBoard: editBoard,
			NewPage: newPage
		};
	})();
	
	return {
		init: init
	};
};

(function(){
	var favoritesPage = new favorites();
	favoritesPage.init();
})();